import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
import {commonConstant} from '@/utils/Constants';
import axios from 'axios';
import { Notification, MessageBox, Message, Loading } from 'element-ui';

const langKey = 'language';
const defaultLang = 'zh-CN';
const langVersionKey = 'lang_version_';
const langVsersionObj = {
  'zh-CN': commonConstant.LANGUAGE_VERSION_ZH_CN,
  en: commonConstant.LANGUAGE_VERSION_EN,
};

// 检查语言版本
const checkLanguageVersion = (lang) => {
  const langVersion = localStorage.getItem(langVersionKey + lang);
  return langVersion == langVsersionObj[lang];
};

// 加载语言包
export const loadLocale = async (locale) => {
  const cachedKey = `lang_${locale}`;
  let cached = localStorage.getItem(cachedKey);
  try {
    cached = cached ? JSON.parse(cached) : null;
  } catch (error) {
    cached = null;
  }
  if (!checkLanguageVersion(locale) || !cached) {
    await axios.get(process.env.LANGUAGE_FILE_URL + locale + '.json')
          .then(response => {
            cached = response.data;
            localStorage.setItem(langVersionKey + locale, langVsersionObj[locale]);
            localStorage.setItem(cachedKey, JSON.stringify(cached));
          })
          .catch(error => {
            Message.error('Load Language Error!')
          });
  }
  return cached;
};

// 初始化i18n实例
let i18n;
export const initI18n = () => {
  const currentLocale = localStorage.getItem(langKey) || defaultLang;
  
  i18n = new VueI18n({
    locale: currentLocale,
    fallbackLocale: defaultLang,
    messages: {}
  });
  
  setLanguage(currentLocale);

  return i18n;
};

// 导出 i18n 实例供外部使用
export { i18n };

// 设置语言
export const setLanguage = async (locale) => {
  if (i18n && locale) {
    let localeMessage = i18n.getLocaleMessage(locale);
    if (Object.keys(localeMessage).length === 0 || !checkLanguageVersion(locale)) {
      localeMessage = await loadLocale(locale);
      i18n.setLocaleMessage(locale, localeMessage);
    }
    i18n.locale = locale;
    localStorage.setItem(langKey, locale);
  }
}


// WEBPACK FOOTER //
// ./src/utils/i18nUtil.js